const tableDataStateConstantsEn = {
  noData: 'No Data',
  noMatchingData: 'No Matching Results Found',
};
export default tableDataStateConstantsEn;
